import type { ReactNode } from 'react';
import { motion, useReducedMotion } from 'motion/react';

/** 앱 공용 마이크로 모션 스프링 — 빠르고 절제된 토스 감각 (landing Hero와 동일 계열) */
export const APP_SPRING = { type: 'spring' as const, stiffness: 260, damping: 28, mass: 0.7 };

interface RiseProps {
  /** 초 단위 지연 — 리스트 스태거는 index * 0.045 정도 */
  delay?: number;
  /** 시작 y 오프셋(px) */
  y?: number;
  className?: string;
  children: ReactNode;
}

/**
 * 마운트 시 살짝 떠오르며 나타나는 등장 래퍼.
 * prefers-reduced-motion에서는 오프셋 없이 즉시 표시된다.
 */
export function Rise({ delay = 0, y = 14, className, children }: RiseProps) {
  const reduced = useReducedMotion();
  if (reduced) return <div className={className}>{children}</div>;
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ ...APP_SPRING, delay }}
    >
      {children}
    </motion.div>
  );
}
